import * as mutations from './consts';
/* eslint-disable */
export default {
  // INIT MUTATIONS
  [mutations.SET_PUBLIC_API_KEY](state, payload) {
    state.publicKey = payload;
  },
  [mutations.SET_UI_THEME](state, payload) {
    state.currentTheme = payload;
  },

  // API MUTATIONS ON PREREQUEST
  [mutations.SET_METHODS](state, payload) {
    state.methods = payload;
  },
  [mutations.SET_SERVICES](state, payload) {
    state.services = payload;
  },

  [mutations.SET_GROUPED_SERVICES](state, payload) {
    state.services = payload;
  },

  [mutations.SET_COMMERCE_ACCOUNT_DATA](state, payload) {
    state.commerceAccountData = payload;
  },

  // UI MUTATIONS
  [mutations.SET_SELECTED_METHOD](state, payload) {
    state.selectedMethod = payload;
  },

  [mutations.SET_SELECTED_SERVICE](state, payload) {
    state.selectedService = payload;
  },

  [mutations.SET_CURRENT_STEP](state, payload) {
    state.currentStep = payload;
  },

  // Navigation bar categories
  [mutations.SET_CATEGORIES_LIST](state, payload) {
    state.categories = payload;
  },

  [mutations.SET_SELECTED_CATEGORY](state, payload) {
    state.selectedCategory = payload;
  },

  [mutations.SET_GROUPED_CATEGORIES](state, payload) {
    state.groupedCategories = payload;
  },

  [mutations.SET_INIT_STATE](state, payload) {
    state.invoiceInitialData = payload;
  },

  [mutations.SET_FLOW_DATA](state, payload) {
    state.flowData = payload;
  },

  [mutations.SET_GLOBAL_LOADER](state, payload) {
    state.showGlobalLoader = payload;
  },

  [mutations.SET_PAYMENT_INVOICE_DATA](state, payload) {
    if (payload.data) {
      state.paymentInvoiceData = payload.data;
    }
  },

  [mutations.SET_CHECKOUT_OPTIONS](state, payload) {
    state.checkoutOptions = payload;
  },

  [mutations.SET_AUTO_PROCESS_DATA](state, payload) {
    state.autoProcessData = payload;
  },

  [mutations.SET_SEARCH_DATA](state, payload) {
    state.searchData = payload;
  },

  [mutations.SET_INVOICE_FLOW_DATA_SHOWN](state, payload) {
    state.isInvoiceFlowDataShown = payload;
  },

  ['SET_CURRENT_STEP'](state, payload) {
    state.currentStep = payload;
    // TODO: Kill the man, who did this
    switch (payload) {
      case 1:
        state.statusBar = {
          step: 1,
          label: 'step__service_select',
        };
        break;
      case 2:
        state.statusBar = {
          step: 2,
          label: 'step__payment_process',
        };
        break;
      case 3:
        state.statusBar = {
          step: 2,
          label: 'step__payment_result',
        };
        break;
      default:
        state.statusBar = {
          step: 1,
          label: 'step__service_select',
        };
        break;
    }
  },

  [mutations.SET_NAVIGATION_DATA](state, payload) {
    state.navigationData = payload;
  },

  [mutations.SET_GLOBAL_ERROR](state, payload) {
    state.globalError = payload;
  },

  [mutations.SET_DISABLED_METHOD](state, code) {
    if (state.disabled_methods.indexOf(code) === -1) {
      state.disabled_methods.push(code);
    }
  },

  [mutations.SET_DISABLED_SERVICE](state, code) {
    if (state.disabled_services.indexOf(code) === -1) {
      state.disabled_services.push(code);
    }
  },

  /**
   *
   * Will show skeletons if true.
   *
   * @param state
   * @param payload - boolean
   * @constructor
   */
  ['SET_APPLICATION_READY_STATE'](state, payload) {
    state.isApplicationReady = payload;
  },
};
